import INavBar from '@src/component/INavBar'
import VerticalSpace from '@src/component/VerticalSpace'
import { Button, Dialog, Picker, Space } from 'antd-mobile'
import { DownFill } from 'antd-mobile-icons'
import { Flex } from 'antd-mobile-v2'
import React, { useState } from 'react'
import './index.scss'

const basicColumns = ['6期', '9期', '12期', '18期', '24期', '36期']

interface CountDataProps {
  total?: string
  downPayment?: string
  proportion?: string
}

const defaultInputData = {
  total: '',
  downPayment: '',
  proportion: '',
}

const defaultResData = {
  firstPay: 0,
  mouthPay: 0,
}

function Counter() {
  const [visible, setVisible] = useState(false)
  const [value, setValue] = useState<any>(['6期'])
  const [countData, setContentData] = useState<CountDataProps>(defaultInputData)
  const [resData, setResData] = useState(defaultResData)

  const resetData = () => {
    setContentData({ ...defaultInputData })
    setValue(['6期'])
    setResData({ ...defaultResData })
  }

  const changeValue = (obj: CountDataProps) => {
    setContentData((tempObj) => ({ ...tempObj, ...obj }))
  }

  const count = () => {
    const { total, downPayment, proportion } = countData

    if (!total || !downPayment || !proportion) {
      Dialog.alert({
        content: '请填写完整表单',
      })
      return
    }

    const [totalNum, downPaymentNum, proportionNum] = [
      parseInt(total),
      parseInt(downPayment) / 100,
      parseFloat(proportion) / 100,
    ]

    const firstPay = totalNum * downPaymentNum

    if (value[0]) {
      const date = parseInt(value[0]?.replace('期', ''))
      // console.log(totalNum, downPaymentNum, proportionNum, date)
      //(((车辆价格-车辆价格*首付比例)*(费率/12)*租赁期数）+{车辆价格-车辆价格*首付比例))/租赁期数
      const mouthPay =
          (((totalNum - totalNum * downPaymentNum) * (proportionNum / 12) * date) + (totalNum - totalNum * downPaymentNum)) / date
      setResData({ firstPay, mouthPay: mouthPay })
    }
  }

  return (
    <>
      <INavBar title="金融计算器" />
      <div className="counter-box">
        <VerticalSpace size={18}>
          <Flex justify="between">
            <span>车辆价格（元）：</span>
            <div className="input-box">
              <input
                type="number"
                value={countData?.total}
                onChange={(e) =>
                  changeValue({
                    total: e.target.value.replace(/[^0-9]/g, ''),
                  })
                }
              />
            </div>
          </Flex>
          <Flex justify="between">
            <span>首付比例（%）：</span>
            <div className="input-box">
              <input
                type="number"
                value={countData?.downPayment}
                onChange={(e) =>
                  changeValue({
                    downPayment: e.target.value.replace(/[^0-9]/g, ''),
                  })
                }
              />
            </div>
          </Flex>
          <Flex justify="between">
            <span>产品费率（%）：</span>
            <div className="input-box">
              <input
                type="text"
                value={countData?.proportion}
                onChange={(e) => {
                  changeValue({
                    proportion: e.target.value.replace(
                      /^\D*(\d*(?:\.\d{0,1})?).*$/g,
                      '$1'
                    ),
                  })
                }}
              />
            </div>
          </Flex>
          <Flex justify="between">
            <span>融租期数：</span>
            <div className="input-box">
              <span>{value[0]}</span>
              <DownFill
                className="pick-icon"
                onClick={() => setVisible(true)}
              />
            </div>
          </Flex>
        </VerticalSpace>
      </div>
      <Space
        justify="center"
        style={{
          width: '100%',
          paddingTop: 41,
          paddingBottom: 17,
          '--gap': '20px',
        }}
      >
        <Button onClick={resetData} className="btn">
          清空
        </Button>
        <Button
          color="primary"
          onClick={count}
          className="btn"
          style={{ background: '#6291DF' }}
        >
          确认
        </Button>
      </Space>
      <VerticalSpace size={14}>
        {resData.firstPay ? (
          <div className="count-res">
            <span>首付款：</span>
            <span>{resData.firstPay.toFixed(2)}</span>
          </div>
        ) : null}
        {resData.mouthPay ? (
          <div className="count-res">
            <span>月供：</span>
            <span>{resData.mouthPay.toFixed(2)}</span>
          </div>
        ) : null}
      </VerticalSpace>
      <Picker
        columns={countData?.total && (Number(countData.total) < 30000) ? [basicColumns.slice(0, basicColumns.length - 1) ] : [basicColumns]}
        visible={visible}
        value={value}
        onConfirm={setValue}
        onClose={() => {
          setVisible(false)
        }}
      />
    </>
  )
}

export default Counter
